import React, { FormEvent, useEffect, useState } from "react";
import { useAuthUserContext } from "../../context/UserContext";
import useQuery from "../../hooks/useQuery";
import PageHeader from "../App/PageHeader";
import styles from "./ResetPasswordPage.module.css";
import Button from "../UserInterfaceElements/Button";
import DarkPage from "../UserInterfaceElements/DarkPage";

const ResetPasswordPage: React.FC = () => {
  const rtk = useQuery("rtk");
  const [resetToken, setResetToken] = useState(rtk || "");
  const [showPasswordField, setShowPasswordField] = useState(false);
  const [password, setPassword] = useState<string>("");
  const {
    exchangeResetToken,
    updatePassword,
    loggedIn,
    error,
    statusMessage,
  } = useAuthUserContext();

  const submitResetToken = async (evt: FormEvent) => {
    evt.preventDefault();
    await exchangeResetToken(resetToken);
  };

  const submitNewPassword = async (evt: FormEvent) => {
    evt.preventDefault();
    if (!password) {
      return;
    }
    await updatePassword(password);
  };

  useEffect(() => {
    setShowPasswordField(loggedIn);
  }, [loggedIn]);

  return (<DarkPage>
    <div className={styles.ResetPasswordPage}>
      <PageHeader>Reset password</PageHeader>
      {error && <p>{error}</p>}
      {statusMessage && <p>{statusMessage}</p>}
      {!showPasswordField && (
        <form className={styles.Form} onSubmit={submitResetToken}>
          <p>Your reset code</p>
          <input
            value={resetToken}
            onChange={(evt) => setResetToken(evt.target.value)}
          />
          <Button type="submit" disabled={!resetToken}>
            Submit code
          </Button>
        </form>
      )}
      {showPasswordField && statusMessage !== "Password changed" && (
        <form className={styles.Form} onSubmit={submitNewPassword}>
          <input
            value={password}
            placeholder={"Enter new password"}
            type="password"
            onChange={(evt) => setPassword(evt.target.value)}
          />
          <Button type="submit" disabled={!password}>
            Update password
          </Button>
        </form>
      )}
      {showPasswordField && statusMessage === "Password changed" && (
          <Button to="/introduction">
            Browse statements
          </Button>
      )}
    </div>
    </DarkPage>);
};

export default ResetPasswordPage;
